<template>
  <div id="wp-pagespeed-score">
    <div class="mx-2">
      <MoskitoTabs
        :options="[
          { value: 'MOBILE', text: $t('editPage.tab:mobile') },
          { value: 'DESKTOP', text: $t('editPage.tab:desktop') },
        ]"
        v-model="tab"
      />
      <div class="border-t">
        <PagespeedReportWrapper
          v-show="tab === 'MOBILE'"
          :reportMeta="{ strategy: 'mobile' }"
        />
        <PagespeedReportWrapper
          v-show="tab === 'DESKTOP'"
          :reportMeta="{ strategy: 'desktop' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MoskitoTabs from "@/moskito-common/components/MoskitoTabs";
import PagespeedReportWrapper from "@/wp-pages/edit-page/components/PagespeedReportWrapper";

const tabs = {
  MOBILE: "MOBILE",
  DESKTOP: "DESKTOP",
};

export default {
  components: { PagespeedReportWrapper, MoskitoTabs },
  data() {
    return {
      tab: tabs.MOBILE,
    };
  },
};
</script>

<style></style>
